const styles = (theme) => ({
  container: {
    position: "fixed",
    width: "100%",
    height: "100%",
    padding: 0,
    boxSizing: "border-box",
    background: "#F8F7FA",
    overflowX: "hidden",
    overflowY: "auto",
  },
  headerWrapper: {
    position: "sticky",
    top: 0,
    zIndex: 1100,
    flexShrink: 0,
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 2px 8px rgba(47, 43, 61, 0.12)",
  },
  headerRow1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 24px",
    minHeight: 48,
  },
  headerRow2: {
    display: "flex",
    alignItems: "center",
    padding: "8px 24px",
    borderTop: "1px solid rgba(47, 43, 61, 0.12)",
  },
  header: {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 2px 8px rgba(47, 43, 61, 0.12)",
    padding: "8px 24px",
    height: "64px",
    maxHeight: "64px",
    display: "flex",
    alignItems: "center",
    position: "sticky",
    top: 0,
    zIndex: 1100,
  },
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  navItems: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    width: "100%",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 16px",
    borderRadius: "6px",
    textDecoration: "none",
    color: "rgba(47, 43, 61, 0.7)",
    fontSize: "0.9375rem",
    fontWeight: 500,
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    whiteSpace: "nowrap",
    transition: "all 0.2s ease-in-out",
    lineHeight: 1.46667,
    letterSpacing: "0.25px",
    "&:hover": {
      backgroundColor: "rgba(47, 43, 61, 0.04)",
      color: "rgba(47, 43, 61, 0.9)",
    },
  },
  navItemActive: {
    background: "linear-gradient(270deg, rgba(255, 132, 75, 0.7) 0%, #FF844B 100%)",
    color: "#FFFFFF",
    fontWeight: 500,
    boxShadow: "0px 2px 6px rgba(255, 132, 75, 0.4)",
    "& svg": {
      stroke: "#FFFFFF",
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#FFFFFF",
    },
  },
  navItemIcon: {
    flexShrink: 0,
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginLeft: "auto",
  },
  accountBoxLeft: {
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
    gap: "8px",
  },
  accountBox: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: "6px",
    marginLeft: "8px",
    "&:hover": {
      backgroundColor: "rgba(47, 43, 61, 0.04)",
    },
  },
  accountName: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: 600,
    fontSize: "0.9375rem",
    color: "rgba(47, 43, 61, 0.9)",
    lineHeight: 1.46667,
  },
  accountCompany: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: 400,
    fontSize: "0.8125rem",
    color: "rgba(47, 43, 61, 0.5)",
    lineHeight: 1.38462,
    letterSpacing: "0.4px",
  },
  logoLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    gap: 12,
  },
  logo: {
    height: 28,
  },
  logoText: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: "1.375rem",
    fontWeight: 700,
    color: "rgba(47, 43, 61, 0.9)",
    letterSpacing: "0.25px",
    lineHeight: 1.09091,
  },
  search: {
    position: "relative",
    width: "220px",
    maxWidth: 300,
  },
  searchIcon: {
    position: "absolute",
    display: "flex",
    marginLeft: 12,
    height: "100%",
    alignItems: "center",
    color: "rgba(47, 43, 61, 0.4)",
    pointerEvents: "none",
    zIndex: 100,
  },
  inputRoot: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: 400,
    fontSize: "0.9375rem",
    width: "100%",
    color: "rgba(47, 43, 61, 0.9)",
  },
  inputInput: {
    width: "100%",
    height: 38,
    padding: 0,
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    paddingRight: 12,
    border: "1px solid rgba(47, 43, 61, 0.12)",
    borderRadius: 6,
    backgroundColor: "#F8F7FA",
    fontSize: "0.9375rem",
    "&:focus": {
      borderColor: "#FF844B",
      backgroundColor: "#FFFFFF",
    },
  },
  menuItemDesc: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: 400,
    fontSize: "0.9375rem",
    color: "rgba(47, 43, 61, 0.9)",
    lineHeight: 1.46667,
  },
  content: {
    padding: "16px 24px",
  },
  createButton: {
    width: 176,
    height: 40,
    marginRight: 10,
    borderRadius: 6,
    backgroundColor: "#FF844B",
    boxShadow: "0px 2px 6px rgba(255, 132, 75, 0.4)",
    border: "none",
    "& .MuiButton-label": {
      fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: "0.9375rem",
      color: "white",
      fontWeight: 500,
      textAlign: "center",
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: "#FF6D00",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginRight: 0,
    },
  },
  projectBox: {
    border: "1px solid rgba(47, 43, 61, 0.12)",
    borderRadius: 6,
    maxWidth: 330,
    userSelect: "none",
    "& .MuiAvatar-root": {
      width: "100%",
      height: 200,
      borderRadius: 0,
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
    },
    "& .MuiAvatar-img": {
      transition: "all .3s ease-in-out",
      filter: "brightness(100%)",
    },
    "& .MuiAvatar-img:hover": {
      cursor: "pointer",
      transform: "scale(1.1)",
      filter: "brightness(110%)",
    },
  },
  projectList: {
    marginBottom: 40,
    userSelect: "none",
    "& .MuiListItem-root:hover": {
      borderRadius: 6,
      textDecoration: "none",
      backgroundColor: "rgba(47, 43, 61, 0.04)",
    },
    "& .MuiAvatar-root": {
      width: 48,
      height: 48,
      borderRadius: 6,
      cursor: "pointer",
      transition: "all .3s ease-in-out",
    },
    "& .MuiAvatar-root:hover": {
      zIndex: 100,
      transform: "scale(1.2)",
    },
  },
  listHeader: {
    padding: "16px 20px",
    color: "rgba(47, 43, 61, 0.5)",
    fontSize: "0.9375rem",
    fontWeight: 500,
    fontStyle: "normal",
    lineHeight: 1.46667,
    "& .MuiSvgIcon-root": {
      width: 20,
      height: 20,
    },
  },
  projectName: {
    color: "rgba(47, 43, 61, 0.9)",
    fontSize: "0.9375rem",
    fontWeight: 600,
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    lineHeight: 1.46667,
  },
  lastViewed: {
    color: "rgba(47, 43, 61, 0.5)",
    fontSize: "0.8125rem",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: 1.38462,
    letterSpacing: "0.4px",
  },
  pagination: {
    "& .MuiPaginationItem-root": {
      color: "rgba(47, 43, 61, 0.5)",
    },
    "& .MuiPaginationItem-textPrimary.Mui-selected": {
      color: "#fff",
    },
  },
  dialogShare: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 684,
    },
    "& .MuiDialog-paper": {
      width: 684,
    },
    "& .MuiDialogTitle-root": {
      padding: 15,
      borderBottom: "1px solid rgba(47, 43, 61, 0.12)",
      fontSize: "1.125rem",
      fontWeight: 500,
      fontStyle: "normal",
      color: "rgba(47, 43, 61, 0.9)",
    },
    "& .MuiDialogContent-root": {
      padding: "24px 32px",
    },
    [theme.breakpoints.down("xs")]: {
      "& .MuiDialog-paperWidthSm": {
        width: "100%",
      },
      "& .MuiDialogContent-root": {
        padding: 20,
      },
    },
  },
  deleteDialog: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 684,
    },
    "& .MuiDialog-paper": {
      width: 684,
    },
    "& .MuiDialogTitle-root": {
      padding: 32,
      borderBottom: "1px solid rgba(47, 43, 61, 0.12)",
      fontSize: "1.25rem",
      fontWeight: 500,
      fontStyle: "normal",
      color: "rgba(47, 43, 61, 0.9)",
    },
    "& .MuiDialogContent-root": {
      padding: "24px 80px",
    },
    [theme.breakpoints.down("xs")]: {
      "& .MuiDialog-paperWidthSm": {
        width: "100%",
      },
      "& .MuiDialogContent-root": {
        padding: 20,
      },
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(2),
    color: theme.palette.grey[800],
  },
  margin: {
    margin: theme.spacing(1),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  dialog: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 592,
      height: 680,
    },
    "& .MuiDialog-paper": {
      width: 592,
      height: "auto",
    },
    "& .MuiDialogTitle-root": {
      fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: "1.25rem",
      fontStyle: "normal",
      fontWeight: 700,
      color: "rgba(47, 43, 61, 0.7)",
      padding: "32px 32px",
      textAlign: "center",
      "&>div:nth-child(1)": {
        width: "100%",
      },
      "&>div:nth-child(2)": {
        borderBottom: "1px solid rgba(47, 43, 61, 0.12)",
        width: "100%",
        height: "20px",
      },
    },
    "& .MuiDialogContent-root": {
      padding: "0px 40px 32px 40px",
      boxSizing: "border-box",
    },
  },
  sectionTitle: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: "0.9375rem",
    fontStyle: "normal",
    fontWeight: 600,
    marginBottom: 24,
    marginLeft: 20,
    lineHeight: 1.46667,
  },
  textBox: {
    marginBottom: 16,
    "& .MuiInputBase-root": {
      width: "auto",
      height: 48,
      borderRadius: 72,
      backgroundColor: "#F8F7FA",
      "& fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        background: "none",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "0.9375rem",
      color: "rgba(47, 43, 61, 0.9)",
      marginLeft: 10,
      background: "none",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#F8F7FA",
    },
    "& .MuiSvgIcon-root": {
      color: "rgba(47, 43, 61, 0.4)",
      marginRight: 10,
    },
  },
  submitButton: {
    width: "100%",
    height: 48,
    background: "#FF844B",
    border: "2px solid #FF844B",
    boxSizing: "border-box",
    borderRadius: 6,
    boxShadow: "0px 2px 6px rgba(255, 132, 75, 0.4)",
    "& .MuiButton-label": {
      fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: "0.9375rem",
      color: "white",
      fontWeight: 500,
      textAlign: "center",
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: "#FF6D00",
    },
  },
  cancelButton: {
    width: "100%",
    height: 48,
    background: "#808390",
    border: "2px solid #808390",
    boxSizing: "border-box",
    borderRadius: 6,
    boxShadow: "0px 2px 6px rgba(128, 131, 144, 0.24)",
    "& .MuiButton-label": {
      fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: "0.9375rem",
      color: "white",
      fontWeight: 500,
      textAlign: "center",
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: "#6b6e7a",
    },
  },
  [theme.breakpoints.down("sm")]: {
    search: {
      position: "relative",
      width: "100%",
      maxWidth: 300,
    },
    headerRow1: {
      padding: "8px 16px",
    },
    headerRow2: {
      padding: "0px 16px 8px 16px",
    },
    navItemText: {
      display: "none",
    },
    logoText: {
      display: "none",
    },
  },
  [theme.breakpoints.down("xs")]: {
    headerRow1: {
      padding: "8px 12px",
    },
    headerRow2: {
      padding: "0px 12px 8px 12px",
    },
    searchVisibility: {
      display: "none",
    },
    navItems: {
      gap: "2px",
    },
    navItem: {
      padding: "8px",
    },
    dialog: {
      zoom: "90%",
    },
  },
  headerTop: {
    height: 52,
    color: "rgba(47, 43, 61, 0.9)",
    fontStyle: "normal",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 2px 8px rgba(47, 43, 61, 0.12)",
    display: "flex",
    alignItems: "center",
    paddingLeft: 24,
    paddingRight: 24,
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 1100,
  },
  rightHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  MenuItem: {
    padding: "10px 16px",
  },
  iconMenu: {
    width: 22,
    height: 22,
    marginRight: 12,
    color: "rgba(47, 43, 61, 0.5)",
  },
  avatarStatusWrapper: {
    position: "relative",
    display: "inline-flex",
  },
  statusBadge: {
    position: "absolute",
    bottom: 2,
    right: 2,
    width: 10,
    height: 10,
    backgroundColor: "#56CA00",
    borderRadius: "50%",
    border: "2px solid #FFFFFF",
    boxSizing: "content-box",
  },
  dropdownHeader: {
    display: "flex",
    alignItems: "center",
    padding: "12px 20px",
    gap: 12,
  },
  dropdownAvatarWrapper: {
    position: "relative",
    display: "inline-flex",
    flexShrink: 0,
  },
  dropdownStatusBadge: {
    position: "absolute",
    bottom: 1,
    right: 1,
    width: 8,
    height: 8,
    backgroundColor: "#56CA00",
    borderRadius: "50%",
    border: "2px solid #FFFFFF",
    boxSizing: "content-box",
  },
  dropdownAvatar: {
    width: 38,
    height: 38,
    border: "none",
  },
  dropdownName: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: 600,
    fontSize: "0.9375rem",
    color: "rgba(47, 43, 61, 0.9)",
    lineHeight: 1.46667,
  },
  dropdownRole: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: 400,
    fontSize: "0.8125rem",
    color: "rgba(47, 43, 61, 0.5)",
    lineHeight: 1.38462,
    letterSpacing: "0.4px",
  },
  dropdownMenuItem: {
    padding: "8px 16px",
    marginLeft: 8,
    marginRight: 8,
    borderRadius: 6,
    gap: 12,
    "& svg": {
      width: 22,
      height: 22,
      color: "rgba(47, 43, 61, 0.5)",
    },
    "&:hover": {
      backgroundColor: "rgba(47, 43, 61, 0.04)",
    },
  },
  logoutButton: {
    margin: "8px 16px 12px",
    backgroundColor: "#FF844B",
    color: "#FFFFFF",
    borderRadius: 6,
    padding: "8px 0",
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: "0.9375rem",
    fontWeight: 500,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    cursor: "pointer",
    border: "none",
    boxSizing: "border-box",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#FF6D00",
    },
  },
});

export default styles;
